import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["serviceSelect", "termSection"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasServiceSelectTarget || !this.hasTermSectionTarget) return
    const isPersonal = this.serviceSelectTarget.value === "personal_classes"
    this.termSectionTarget.classList.toggle("hidden", isPersonal)
  }
}
